import exportCompoent from "@/components/export/ExportComponent.vue";

const pages = {
  components: {
    exportCompoent,
  },
  data() {
    return {
      isShowDialog_dc: false,
      diaWidth_dc: "60%",
      dialogTitle_dc: "导出数据",
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "", //
        apiName: "", //当前数据列表的文件名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        pageType: "", //页面类型(主要用来区分查询参参数的时间)
      },
      myTableHeard: [],
      EPtableHeard: [],
      EPAllCheck: false,
    };
  },
  created() {},
  watch: {
    isShowDialog_dc(a, b) {
      if (a) {
        this.EPtableHeard = this.myTableHeard;
        let flag = true;
        this.EPtableHeard.forEach((item) => {
          if (item.isShow == false) {
            flag = false;
          }
        });
        this.EPAllCheck = flag;
      }
    },
  },
  methods: {
    // 关闭弹窗
    handleCloseDia_dc(e) {
      this.isShowDialog_dc = false;
    },
    // 点击某一项(表格设置)
    checktabEP(idx, e, arrs) {
      let that = this;
      arrs[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < arrs.length; i++) {
        if (arrs[i].isShow) {
          selectLength++;
        }
      }
      if (selectLength == arrs.length) {
        that.EPAllCheck = true;
      } else {
        that.EPAllCheck = false;
      }
      this.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    //全选(表格设置)
    checkAllEP(e, arrs) {
      let that = this;
      that.EPAllCheck = e;
      for (var j = 0; j < arrs.length; j++) {
        arrs[j].isShow = e;
      }
      this.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    // 拖拽过后 更新数组
    onAfterEnter(arrs) {
      this.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },

    // 确定按钮
    diaConfirmBtn_dc() {
      let that = this;

      // 暂时这样写,以后再改造成功动态查询条件的
      let param = JSON.parse(JSON.stringify(that.queryData)) || {};
      // 综合查询 时间
      if (this.dialogForm_dc.pageType == "ComprehensiveQuery") {
        let startBusinessTime = "";
        let endBusinessTime = "";
        let startCreateTime = "";
        let endCreateTime = "";
        let startTakeTime = "";
        let endTakeTime = "";
        let startSendTime = "";
        let endSendTime = "";

        let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
        let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

        if (this.timeType == "0") {
          startCreateTime = startTime;
          endCreateTime = endTime;
        }
        if (this.timeType == "1") {
          startBusinessTime = startTime;
          endBusinessTime = endTime;
        }
        if (this.timeType == "2") {
          startTakeTime = startTime;
          endTakeTime = endTime;
        }
        if (this.timeType == "3") {
          startSendTime = startTime;
          endSendTime = endTime;
        }

        param.startBusinessTime = startBusinessTime;
        param.endBusinessTime = endBusinessTime;
        param.startCreateTime = startCreateTime;
        param.endCreateTime = endCreateTime;
        param.startTakeTime = startTakeTime;
        param.endTakeTime = endTakeTime;
        param.startSendTime = startSendTime;
        param.endSendTime = endSendTime;
      }
      // 待配载列表 时间
      else if (this.dialogForm_dc.pageType == "TasksLoaded") {
        let startTaskCreateTime = ""; //
        let endTaskCreateTime = ""; //

        let startCreateTime = ""; //创建时间 开始
        let endCreateTime = ""; //创建时间 结束
        if (this.timeType == 1) {
          // 1==创建时间
          startCreateTime = this.startTime_a
            ? this.startTime_a + " 00:00:00"
            : "";
          endCreateTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
        } else {
          //业务时间
          startTaskCreateTime = this.startTime_a
            ? this.startTime_a + " 00:00:00"
            : "";
          endTaskCreateTime = this.endTime_a
            ? this.endTime_a + " 23:59:59"
            : "";
        }

        param.startTaskCreateTime = startTaskCreateTime;
        param.endTaskCreateTime = endTaskCreateTime;
        param.startCreateTime = startCreateTime;
        param.endCreateTime = endCreateTime;
        param.dispatchStatus = "wei_pei_zai:dispatch_status";
      }
      // 运输任务 时间
      else if (this.dialogForm_dc.pageType == "TransportationPlann") {
        let startTaskCreateTime = ""; //业务时间 开始
        let endTaskCreateTime = ""; //业务时间 结束

        let startCreateTime = ""; //创建时间 开始
        let endCreateTime = ""; //创建时间 结束
        if (this.timeType == 1) {
          // 1==创建时间
          startCreateTime = this.startTime_a
            ? this.startTime_a + " 00:00:00"
            : "";
          endCreateTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
        } else {
          //业务时间
          startTaskCreateTime = this.startTime_a
            ? this.startTime_a + " 00:00:00"
            : "";
          endTaskCreateTime = this.endTime_a
            ? this.endTime_a + " 23:59:59"
            : "";
        }
        param.startTaskCreateTime = startTaskCreateTime;
        param.endTaskCreateTime = endTaskCreateTime;
        param.startCreateTime = startCreateTime;
        param.endCreateTime = endCreateTime;
      }
      // 配载批次
      else if (this.dialogForm_dc.pageType == "VehicleStowage") {
        let startDepartureTime = "";
        let startCreateTime = "";
        let endDepartureTime = "";
        let endCreateTime = "";
        let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
        let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
        if (this.timeType == "0") {
          // 创建日期
          startCreateTime = startTime;
          endCreateTime = endTime;
        } else if (this.timeType == "1") {
          // 发车日期
          startDepartureTime = startTime;
          endDepartureTime = endTime;
        }

        param.startCreateTime = startCreateTime;
        param.endCreateTime = endCreateTime;
        param.startDepartureTime = startDepartureTime;
        param.endDepartureTime = endDepartureTime;
      }
      // 外发管理
      else if (this.dialogForm_dc.pageType == "OutgoingManage") {
        let startOutgoingTime = "";
        let endOutgoingTime = "";
        let startCreateTime = "";
        let endCreateTime = "";

        let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
        let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

        if (this.timeType == "0") {
          startCreateTime = startTime;
          endCreateTime = endTime;
        }
        if (this.timeType == "1") {
          startOutgoingTime = startTime;
          endOutgoingTime = endTime;
        }

        let param = this.queryData;
        param.startOutgoingTime = startOutgoingTime;
        param.endOutgoingTime = endOutgoingTime;
        param.startCreateTime = startCreateTime;
        param.endCreateTime = endCreateTime;
      }
      // 异常列表
      else if (this.dialogForm_dc.pageType == "ExceptionManage") {
        let startCreateTime = "";
        let endCreateTime = "";
        let startHappenTime = "";
        let endHappenTime = "";
        let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
        let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
        if (this.timeType == "0") {
          // 创建日期
          startCreateTime = startTime;
          endCreateTime = endTime;
        } else if (this.timeType == "1") {
          // 发生日期
          startHappenTime = startTime;
          endHappenTime = endTime;
        }
        param.startCreateTime = startCreateTime;
        param.endCreateTime = endCreateTime;
        param.startHappenTime = startHappenTime;
        param.endHappenTime = endHappenTime;
      }
      param.pageStart = this.dialogForm_dc.pageStart;
      param.pageTotal = this.dialogForm_dc.pageTotal;

      console.log("param", param);

      let hArrs = [];
      this.EPtableHeard.forEach((element) => {
        if (element.isShow) {
          if (element.child && element.child.length) {
            element.child.forEach((element1) => {
              if (element1.isShow) {
                hArrs.push({
                  fieldKey: element1.field,
                  titleValKey: element1.name,
                });
              }
            });
          } else {
            hArrs.push({
              fieldKey: element.field,
              titleValKey: element.name,
            });
          }
        }
      });

      let d = {
        fileName: this.dialogForm_dc.fileName || "fileName",
        headsTitles: JSON.stringify(hArrs), //表头 数组
        pageCount: this.dialogForm_dc.pageTotal || 20000, //数据总条数 最多两万
        post: this.dialogForm_dc.apiType || "GET",
        selectDto: JSON.stringify(param), //列表查询条件
        sheetName: this.dialogForm_dc.fileName || "sheetName",
        url: this.$COMMON.baseURL + this.dialogForm_dc.apiName,
        isJson: 0, //是否json 1= 是 0= 否
      };

      if (this.dialogForm_dc.EpType === "dd") {
        // 等待导出完成
        // 生成导出文件流,前端转换下载
        this.$API.exportExcelByUrl(d).then((res) => {
          let data = res.data;
          // 获取响应的文件流数据
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          let url = URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = (this.dialogForm_dc.fileName || "导出文件") + ".xlsx"; // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url); // 撤销URL对象

          setTimeout(() => {
            that.isShowDialog_dc = false;
          }, 1000);
        });
      } else {
        // 导出(生成历史记录),只返回提示
        this.$API.exportExcelToRecord(d).then((res) => {
          this.$message.success("数据处理中,请到右上角导出记录中查询结果");
          setTimeout(() => {
            that.isShowDialog_dc = false;
          }, 1000);
        });
      }

      // 导出,返回下载链接
      // this.$API.exportExcelToUrl(d).then(res => {
      //     let data = res.data
      //     // 获取响应的文件流数据

      //     let url = data.result.url;

      //     // 创建一个链接并设置其属性
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.setAttribute('download', this.dialogForm_dc.fileName);

      //     // 在DOM中添加链接并自动点击以执行下载
      //     document.body.appendChild(link);
      //     link.click();

      //     // 下载完成后，清除链接
      //     document.body.removeChild(link);

      // })
    },
  },
};

export default pages;
